import { Logger, LoggerService } from '@Shared/logger';
import { PipelineContext, PipelineStep } from '@Modules/pipeline_module/_base';
import { ScreenManager } from '@Modules/ui_module/screen-manager/screen-manager';
import { AsyncUtils } from '@Shared/utils/async';
import { PaywayService } from '@Modules/payway_module/services/payway.service';
export class ProcessNewStartStep implements PipelineStep {
    private Logger: Logger = LoggerService.createLogger('ProcessNewStartStep');

    constructor() {
        this.Logger.trace('****  CTOR ****');
    }

    async execute(context: PipelineContext): Promise<PipelineStep | null> {
        this.Logger.trace('Executing....', context);
        const screenManager = ScreenManager.Instance;
        screenManager.CurrentScreen?.Alert?.hide();
        screenManager.showScreen('processNewStart');
        await PaywayService.Instance.processNewSubscriptionStart();
        
        screenManager.closeScreen();
        window.location.reload();
        return null;
    }
}